import { fetchApi } from 'api/fetchApi'

import { SearchRequest } from './search.types'

export const fetchSearchSettingsApi = () =>
  fetchApi<SearchRequest>('/search/options')
